import { motion } from "framer-motion";
import { X, Check, ArrowRight } from "lucide-react";
import { SWITCH_LIST } from "@/lib/site";

export default function FeatureIntro() {
  return (
    <section id="cambiar" data-testid="feature-intro" className="relative py-20 md:py-28">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20">
          <span className="chip mb-5">
            <span className="dot" /> Por qué las clínicas top están cambiando
          </span>
          <h2
            className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-bold text-[#0B0B14] tracking-tight leading-[1.05] max-w-3xl mx-auto"
          >
            Cómo compras hoy vs. cómo <span className="text-[#5A48C9]">deberías estar comprando.</span>
          </h2>
          <p className="mt-6 text-[#3A3A48] max-w-xl mx-auto leading-relaxed">
            Si estás comprando más de 100 fillers al mes, tu proveedor te está tratando
            como una clínica de 20. Este es el estándar del Programa Clamignon.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {/* PAIN card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            data-testid="feature-card-left"
            className="card-soft p-8 md:p-10 relative"
          >
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#B03A3A] mb-4 inline-block">
              El proveedor actual
            </span>
            <h3 className="font-display text-2xl md:text-3xl font-bold text-[#0B0B14] mb-6 tracking-tight">
              {SWITCH_LIST.painTitle}
            </h3>
            <ul className="space-y-3 text-[#3A3A48] text-[15px] leading-relaxed">
              {SWITCH_LIST.pain.map((line) => (
                <li key={line} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[#F9E3E3] flex items-center justify-center flex-shrink-0">
                    <X className="w-3 h-3 text-[#B03A3A]" strokeWidth={2.5} />
                  </span>
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* GAIN card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            data-testid="feature-card-right"
            className="card-glass p-8 md:p-10 flex flex-col relative"
          >
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5A48C9] mb-4 inline-block">
              Programa Clamignon
            </span>
            <h3 className="font-display text-2xl md:text-3xl font-bold text-[#0B0B14] mb-6 tracking-tight">
              {SWITCH_LIST.gainTitle}
            </h3>
            <ul className="space-y-3 text-[#2A2A3A] text-[15px] leading-relaxed">
              {SWITCH_LIST.gain.map((line) => (
                <li key={line} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-[#5A48C9]" strokeWidth={2.5} />
                  </span>
                  <span>{line}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <a data-testid="feature-cta" href="#contacto" className="btn-pill btn-primary shine">
                Solicitar evaluación
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
